import React, { FC, useEffect } from 'react';
import { VStack } from '@chakra-ui/react';
import EnterAmountCard from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmountsCard';
import { Currency, Field } from '@cryptoalgebra/kim-sdk';
import {
  useLiquidityWizardState,
  useMintActionHandlers
} from '@app/screens/liquidity/LiquidityWizard/state';
import { IDerivedMintInfoWithProvider } from '@app/state/mintStore';
import { IDerivedLiquidityByGammaInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedGammaMintInfo';

interface Props {
  mintInfo: IDerivedMintInfoWithProvider | IDerivedLiquidityByGammaInfo;
}

export const AmountsInput: FC<Props> = ({ mintInfo }) => {
  const { independentField, typedValue, currencyA, currencyB } =
    useLiquidityWizardState();

  const { onFieldAInput, onFieldBInput } = useMintActionHandlers(false);

  const formattedAmounts = {
    [independentField]: typedValue,
    [mintInfo.dependentField]:
      mintInfo.parsedAmounts[mintInfo.dependentField]?.toSignificant(6) ?? ''
  };

  useEffect(() => {
    return () => {
      onFieldAInput('');
      onFieldBInput('');
    };
  }, [onFieldAInput, onFieldBInput]);

  return (
    <>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyA}
          value={formattedAmounts[Field.CURRENCY_A]}
          handleChange={value => onFieldAInput(value)}
          isDisabled={false}
        />
      </VStack>
      <VStack w="100%">
        <EnterAmountCard
          currency={currencyB}
          value={formattedAmounts[Field.CURRENCY_B]}
          handleChange={value => onFieldBInput(value)}
          isDisabled={false}
        />
      </VStack>
    </>
  );
};
